//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sync } from 'vuex-pathify'
import DeleteOutlineIcon from 'vue-material-design-icons/DeleteOutline.vue'

export default {
  name: 'CartMenu',
  components: { DeleteOutlineIcon },
  data() {
    return {
      open: false,
      quantityOption: Array.from({ length: 20 }, (_, i) => i + 1),
      needToRegister: false,
      showLogin: false,
      waitingForPin: false,
      confirmationEmail: null,
      password: null,
      loading: false,
      cartItems: []
    }
  },
  computed: {
    cartItemsStore: sync('cart/items'),
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    formatter() {
      return new Intl.NumberFormat(this.language, {
        style: 'decimal',
        maximumFractionDigits: 2
      })
    },
    total() {
      return (
        this.cartItems
          .filter((x) => !x.isLoading)
          .map((x) => x.price * x.quantity)
          .reduce((a, b) => a + b, 0) -
        this.cartItems
          .filter((x) => !x.isLoading && x.isUpgrade && x.credit > 0)
          .map((x) => x.credit)
          .reduce((a, b) => a + b, 0)
      )
    },
    account() {
      return this.$store.get('user/user') || null
    },
    canCheckOut() {
      return this.cartItems.length > 0 && this.cartItems.filter((x) => x.isLoading).length === 0
    }
  },
  watch: {
    cartItemsStore() {
      this.cartItems = JSON.parse(JSON.stringify(this.cartItemsStore))
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('openCart')
    this.$nuxt.$off('onCartItemAdded')
  },
  mounted() {
    this.cartItems = JSON.parse(JSON.stringify(this.cartItemsStore))

    this.$nuxt.$on('openCart', this.toggle)

    this.$nuxt.$on('onCartItemAdded', async (id, upgradingId) => {
      this.$nuxt.$emit('openingCart', true)

      let cartItem = { id, isLoading: true, quantity: 1 }
      if (this.cartItems.some((x) => x.id === id)) {
        cartItem = this.cartItems.find((x) => x.id === id)
        cartItem.quantity = cartItem.quantity + 1

        const targetIndex = this.cartItems.findIndex((x) => x.id === id)
        this.cartItems[targetIndex] = cartItem
      } else {
        this.cartItems.push(cartItem)

        const targetIndex = this.cartItems.findIndex((x) => x.id === id)
        const item = await this.getCartItem(id, upgradingId)
        if (item) {
          cartItem.isLoading = false
          cartItem = { ...item, id: cartItem.id }
          this.cartItems[targetIndex] = cartItem
        } else {
          this.$buefy.toast.open({
            message: this.$t('error.something_went_wrong'),
            type: 'is-danger'
          })
          this.cartItems = this.cartItems.filter((x) => x.id !== id)
        }
      }

      this.saveCartItems()
      this.toggle(true)
    })
  },
  methods: {
    closeCart() {
      this.open = false
      this.$nuxt.$emit('openingCart', this.open)
    },
    toggle(open) {
      if (open != null) {
        this.open = open
      } else {
        this.open = !this.open
      }
    },
    onRemoveItem(id) {
      this.cartItems = this.cartItems.filter((x) => x.id !== id)
      this.saveCartItems()
    },
    onContinueShoppingClick() {
      this.open = false
      this.$nuxt.$emit('openingCart', this.open)

      if (this.$route.path === '/payment') {
        this.$router.replace({ path: '/' })
      }
    },
    onProceedCheckout() {
      if (!this.account) {
        this.needToRegister = true
      } else {
        const params = {}
        params.redirectPath = this.$route.path

        this.$nuxt.$emit('openingCart', false)
        this.$router.push({ name: 'payment', params })
        this.open = false
      }
    },
    onLoginClicked() {
      this.showLogin = true
    },
    onRegisterClicked() {
      this.showLogin = false
    },
    onUserRegistered(result) {
      this.confirmationEmail = result.email
      this.password = result.password
      this.waitingForPin = true
    },
    onUserConfirmed() {
      this.needToRegister = false
      this.showLogin = false
    },
    onUserLoggedIn() {
      this.needToRegister = false
      this.showLogin = false
    },
    async getCartItem(id, upgradingId) {
      try {
        const response = await this.$axios.$get(
          `${this.$config.apiRestUrl}/order/productprice/${id}${upgradingId ? `?upgradingId=${upgradingId}` : ''}`
        )

        return response
      } catch (error) {
        return null
      }
    },
    saveCartItems() {
      this.$store.set('cart/items', this.cartItems)
      this.cartItems = JSON.parse(JSON.stringify(this.cartItemsStore))
    },
    showCart() {
      this.needToRegister = false
      this.showLogin = false
    }
  }
}
